export const DownArrow = (props: { color?: string }) => {
    return (
        <div data-testid="down-arrow-icon-wrapper">
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="&#240;&#159;&#167;&#172; chevron-down">
                    <path
                        id="Vector"
                        d="M4.49495 5.8293C4.42968 5.89449 4.3779 5.97191 4.34257 6.05714C4.30725 6.14236 4.28906 6.23371 4.28906 6.32596C4.28906 6.41822 4.30725 6.50957 4.34257 6.59479C4.3779 6.68001 4.42968 6.75743 4.49495 6.82263L7.52628 9.86063C7.58821 9.92271 7.66178 9.97197 7.74277 10.0056C7.82377 10.0392 7.91059 10.0565 7.99828 10.0565C8.08597 10.0565 8.1728 10.0392 8.2538 10.0056C8.33479 9.97197 8.40836 9.92271 8.47028 9.86063L11.5036 6.82196C11.6352 6.69041 11.7091 6.512 11.7091 6.32596C11.7091 6.13993 11.6352 5.96151 11.5036 5.82996C11.3721 5.69841 11.1937 5.62451 11.0076 5.62451C10.8216 5.62451 10.6432 5.69841 10.5116 5.82996L7.99828 8.3473L5.48628 5.82996C5.42121 5.76483 5.34395 5.71317 5.2589 5.67792C5.17385 5.64266 5.08268 5.62452 4.99062 5.62452C4.89855 5.62452 4.80739 5.64266 4.72234 5.67792C4.63729 5.71317 4.56002 5.76483 4.49495 5.82996V5.8293Z"
                        fill={props.color ?? '#F7F7F8'}
                    />
                </g>
            </svg>
        </div>
    )
}
